import React from "react";
import Label from "./Label";
import CourseCodeInput from "./CourseCodeInput";

const CourseCode = (props) => {
  const cc_a = props.course_code_a.split(",");
  const course_code = cc_a.map((v, i) => {
    let key = "ccode-" + i;
    let display = v; //just a value display, not an input element
    let input; //display the value in an input element
    if (i == 0 || i + 1 == cc_a.length) {
      input = (
        <CourseCodeInput
          inputType="text"
          inputKey={key}
          value={v}
          handleChange={props.handleCodeChange}
        />
      );
    } else {
      input = (
        <CourseCodeInput
          inputType="number"
          inputKey={key}
          value={v}
          handleChange={props.handleCodeChange}
        />
      );
    }
    return (
      <div
        id={key}
        key={key}
        className="bg-light card d-flex flex-row justify-content-center sm-buffer-right"
        style={{ width: "3rem", height: "2rem" /*fontSize: "2rem" */ }}
        onClick={(e) => props.focus(key, e)}
      >
        {props.focusKey == key ? input : display}
      </div>
    );
  });
  let subjKey = "ccodesubj";
  const subjMap = props.subjectOpts.reduce((m, v) => {
    m[v.id] = v;
    return m;
  }, {});
  const subj =
    props.focusKey == subjKey ? (
      <CourseCodeInput
        inputType="subj"
        subjects={props.subjectOpts}
        value={props.subject || 1}
        inputKey={subjKey}
        handleChange={props.handleSubjChange}
      />
    ) : props.subject ? (
      subjMap[props.subject].name
    ) : (
      ""
    );

  return (
    <div
      id="test-ccode"
      className="d-flex flex-row justify-content-left top-buffer"
    >
      <Label text="Course Code:" />
      <div className="d-flex" style={{ maxWidth: "26rem" }}>
        <div
          id={subjKey}
          className="bg-light card d-flex flex-row justify-content-center sm-inner-buffer-horizontal sm-buffer-right"
          style={{ maxWidth: "10rem", height: "2rem" /* fontSize: "2rem" */ }}
          onClick={(e) => props.focus(subjKey, e)}
        >
          {subj}
        </div>
        {course_code}
      </div>
    </div>
  );
};

export default CourseCode;
